<template>
  <div class="register mt-4">
    <div class="card-confirm-register"></div>
    <v-card
      class="mx-auto card-confirm-register"
      max-width="800"
      v-if="registerResultStatus === true && registerResult !== null"
    >
      <v-card-subtitle class="pb-0 register-title"
        ><h3>
          {{
            $t('register-page.register-success.confirm-success-title', {
              split: '/'
            })
          }}
        </h3>
      </v-card-subtitle>

      <v-card-text class="text--primary mt-3">
        <div>
          {{
            $t('register-page.register-success.line-1', {
              split: '/'
            })
          }}
        </div>

        <div>
          {{
            $t('register-page.register-success.line-2', {
              split: '/'
            })
          }}
        </div>
      </v-card-text>

      <v-card-text class="text--primary">
        <div class="ml-5 text-code">
          {{
            $t('register-page.register-success.line-3', {
              split: '/'
            })
          }}
          {{ registerResult !== null && registerResult.entry_no }}
        </div>
      </v-card-text>

      <v-card-actions class="d-flex flex-row justify-center">
        <div class="my-5 text-center">
          <router-link tag="button" class="btn-next" :to="pathDefault">{{
            $t('register-page.btn.btn-return-login', {
              split: '/'
            })
          }}</router-link>
        </div>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ConfirmSuccess',
  components: {},
  data: () => {
    return {
      locale: 'vi'
    };
  },

  methods: {},
  watch: {
    registerResultStatus: function (val) {
      if (val === false) {
        this.$router.replace(this.pathDefault);
        this.$store.dispatch('confirmMailResetState');
      } else {
        return val;
      }
    },
    $route: function () {
      const { params } = this.$route;

      if (typeof params.token !== 'undefined') {
        const { token } = params;

        this.$store.dispatch('confirmMailRegister', { token });
      }
    }
  },

  computed: {
    ...mapGetters({
      c_time_zone: 'getCTimeZone',
      registerResult: 'getRegisterResult',
      registerResultStatus: 'getRegisterResultStatus'
    })
  },

  created() {
    const { params } = this.$route;

    if (typeof params.token !== 'undefined') {
      const { token } = params;

      this.$store.dispatch('confirmMailRegister', { token });
    }
  }
};
</script>

<style>
.register-title {
  color: #333 !important;
}
.text-code {
  font-weight: 600;
  color: #333;
}
@media only screen and (max-width: 320px) {
  .btn-next {
    padding: 0px 10px !important;
  }
}
</style>
